function initializeProductSizing(root) {
  root.querySelectorAll('[data-product-sizing]').forEach(product => {
    if (product.dataset.sizingReady) return;
    const source = product.querySelector('[data-product-description]');
    const guide = product.querySelector('[data-size-guide]');
    const chart = product.querySelector('[data-size-chart]');
    if (!source || !guide || !chart) return;
    const tables = Array.from(source.querySelectorAll('table'));
    if (!tables.length) return;
    tables.forEach(table => {
      const parent = table.parentElement;
      chart.appendChild(table);
      if (parent !== source && !parent.textContent.trim() && !parent.children.length) parent.remove();
    });
    source.querySelectorAll('p').forEach(note => {
      if (note.textContent.trim() === 'Flat garment measurements.') chart.appendChild(note);
    });
    guide.hidden = false;
    const summary = product.querySelector('[data-product-summary]');
    if (summary) summary.textContent = summary.dataset.detailsLabel;
    product.querySelectorAll('.yp-size-link').forEach(link => {
      link.href = '#' + guide.id;
      link.addEventListener('click', event => {
        event.preventDefault();
        guide.open = true;
        guide.querySelector('summary').focus({preventScroll:true});
        guide.scrollIntoView({block:'start',behavior:'instant'});
      });
    });
    product.dataset.sizingReady = 'true';
  });
}
initializeProductSizing(document);
document.addEventListener('shopify:section:load', event => initializeProductSizing(event.target));

